import { createContext } from 'react';

import { useDrawerInit } from './hooks/use-drawer-init';

type DrawerContextProps = ReturnType<typeof useDrawerInit> | undefined;
export const DrawerContext = createContext<DrawerContextProps>(undefined);
DrawerContext.displayName = 'DrawerContext';
